import React from "react";
import GradientBorderCard from "@/components/brand/GradientBorderCard";
import FadeUp from "@/components/brand/FadeUp";

export const FounderNote = ({ heading = "A note from Samantha Sims" }) => {
    return (
        <section className="vfs-section" data-testid="founder-note-section">
            <div className="vfs-container">
                <FadeUp>
                    <GradientBorderCard radius={24}>
                        <div className="p-7 sm:p-10 lg:p-14">
                            <span
                                aria-hidden="true"
                                className="block text-6xl leading-none mb-4"
                                style={{
                                    fontFamily: "'Space Grotesk', sans-serif",
                                    background:
                                        "linear-gradient(135deg, #EC4899 0%, #8B5CF6 50%, #3B82F6 100%)",
                                    WebkitBackgroundClip: "text",
                                    backgroundClip: "text",
                                    color: "transparent",
                                }}
                            >
                                &ldquo;
                            </span>
                            <h2 className="vfs-h2 mb-5">{heading}</h2>
                            <p className="vfs-body text-lg leading-relaxed max-w-3xl" style={{ color: "var(--text-primary)" }}>
                                I started Vibe for Success because I believe
                                students need more than generic career advice.
                                They need a chance to build something, make
                                decisions, use modern tools, and see themselves
                                as capable. Future Builders Lab is designed to
                                give students a practical, creative first step
                                into the AI-era workforce.
                            </p>
                            <div
                                className="mt-7 pt-6 border-t"
                                style={{
                                    borderColor: "rgba(255,255,255,0.10)",
                                }}
                            >
                                <p
                                    className="font-semibold text-base"
                                    style={{
                                        fontFamily:
                                            "'Space Grotesk', sans-serif",
                                        color: "var(--text-primary)",
                                    }}
                                    data-testid="founder-name"
                                >
                                    Samantha Sims
                                </p>
                                <p
                                    className="text-sm mt-1"
                                    style={{ color: "var(--text-secondary)" }}
                                >
                                    Founder, Vibe for Success, Inc.
                                </p>
                                <p
                                    className="text-sm"
                                    style={{ color: "var(--text-secondary)" }}
                                >
                                    Founder, PrismForge Digital
                                </p>
                            </div>
                        </div>
                    </GradientBorderCard>
                </FadeUp>
            </div>
        </section>
    );
};

export default FounderNote;
